import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { useDeviceType } from '../../hooks/useDeviceType';

const Footer = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  
  const { isMobile } = useDeviceType();
  
  const footerStyle = {
    background: colors.headerBackground,
    backdropFilter: 'blur(10px)',
    padding: isMobile ? '1rem' : '1rem 2rem',
    textAlign: 'center',
    borderTop: `1px solid ${colors.border}`,
    marginTop: 'auto'
  };

  const contentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    color: colors.textSecondary,
    fontSize: isMobile ? '0.8rem' : '0.9rem'
  };

  return (
    <footer style={footerStyle}>
      <div style={contentStyle}>
        <p>{t('footer.copyright')}</p>
        <p style={{ 
          fontSize: isMobile ? '0.7rem' : '0.8rem', 
          marginTop: '0.5rem', 
          opacity: 0.7,
          lineHeight: '1.3'
        }}>
          {t('footer.api')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
